import { useQuery, useMutation } from "@tanstack/react-query";
import api from "@services/api";

export function useTimeSlotSettingsQuery(filters) {
  return useQuery({
    queryKey: ["time-slot-settings", filters],
    queryFn: async () => {
      const params = {
        date: filters.date || undefined,
        week_day: filters.week_day || undefined,
        order_type: filters.order_type || undefined,
        enable: filters.enable || undefined,
      };
      const { data } = await api.get("/time-slot-settings", { params });
      return data;
    },
    keepPreviousData: true,
  });
}

export function useSaveTimeSlotSettingsMutation() {
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post("/time-slot-settings", payload);
      return data;
    },
  });
}

